import * as React from "react";
import {Tab, TabLink, TabList, Tabs} from "bloomer";
import {TAB_NAMES} from "./TabNames";
import About from "../About";
import APIDocs from "../APIDocs";

interface ITabPanelProps {
    modelName: string;
    modelDescription: any;
    content: any;
}

interface ITabPanelState {
    activeTabName: string;
}

class TabPanel extends React.Component<ITabPanelProps, ITabPanelState> {
    constructor(props: ITabPanelProps) {
        super(props);

        this.state = {
            activeTabName: TAB_NAMES.DEMO
        };
    }

    public render() {
        return <React.Fragment>
            <Tabs>
                <TabList isAlign="center" style={{borderBottomStyle: 'none'}}>
                    <Tab isActive={this.state.activeTabName === TAB_NAMES.DEMO}>
                        <TabLink onClick={() => {
                            this.setState({activeTabName: TAB_NAMES.DEMO});
                        }}>
                            <span>{TAB_NAMES.DEMO}</span>
                        </TabLink>
                    </Tab>
                    <Tab isActive={this.state.activeTabName === TAB_NAMES.ABOUT}>
                        <TabLink onClick={() => {
                            this.setState({activeTabName: TAB_NAMES.ABOUT});
                        }}>
                            <span>{TAB_NAMES.ABOUT}</span>
                        </TabLink>
                    </Tab>
                    <Tab isActive={this.state.activeTabName === TAB_NAMES.INSTALL_AND_RUN}>
                        <TabLink onClick={() => {
                            this.setState({activeTabName: TAB_NAMES.INSTALL_AND_RUN});
                        }}>
                            <span>{TAB_NAMES.INSTALL_AND_RUN}</span>
                        </TabLink>
                    </Tab>
                </TabList>
            </Tabs>
            {
                this.state.activeTabName === TAB_NAMES.DEMO ? <div style={{width: '90%', marginTop: "-20px"}}>
                    {this.props.modelDescription}
                    {this.props.content}
                </div> : <></>
            }
            {
                this.state.activeTabName === TAB_NAMES.ABOUT ? <div style={{width: '90%', marginTop: "-20px"}}>
                        <About modelName={this.props.modelName}/>
                </div> : <></>
            }
            {
                this.state.activeTabName === TAB_NAMES.INSTALL_AND_RUN ? <div style={{width: '100%', marginTop: "-30px", overflowX: "auto"}}>
                    <APIDocs modelName={this.props.modelName}/>
                </div> : <></>
            }
        </React.Fragment>;
    }
}

export default TabPanel;


// WEBPACK FOOTER //
// ./src/components/model/TabPanel/index.tsx